<template>
  <div>
    <div class="demo-title">
      OSS直传
      <span class="demo-subtitle">(OSS Server对域名有限制,请使用代理或者修改hosts)</span>
    </div>
    <div class="bx-uploader bx-uploader-oss">
      <input class="bx-input-file" type="file"/>
      <div class="bx-preview">
        <img v-if="imageOSS" :src="imageOSS"/>
      </div>
      <div class="bx-upload" v-if="!imageOSS">
        <img class="upload-background" src="//media.winbaoxian.com/autoUpload/common/idCard_9e638c5329de848.png"/>
        <img class="upload-btn" src="//media.winbaoxian.com/autoUpload/common/btn-upload_46483e95444d6cc.png"/>
      </div>
    </div>
    <div class="demo-title">
      服务端上传
      <span class="demo-subtitle">(没有可使用的接口演示)</span>
    </div>
    <div class="bx-uploader bx-uploader-server">
      <input class="bx-input-file" type="file"/>
      <div class="bx-preview">
        <img v-if="imageServer" :src="imageServer"/>
      </div>
      <div class="bx-upload" v-if="!imageServer">
        <img class="upload-background" src="//media.winbaoxian.com/autoUpload/common/idCard_9e638c5329de848.png"/>
        <img class="upload-btn" src="//media.winbaoxian.com/autoUpload/common/btn-upload_46483e95444d6cc.png"/>
      </div>
    </div>
    <div class="demo-title">
      Base64文件上传
      <span class="demo-subtitle">(OSS直传)</span>
    </div>
    <div class="bx-uploader bx-uploader-base64">
      <div>
        <textarea class="bx-uploader-textarea" rows="5" placeholder="请输入base64格式内容" v-model="base64"></textarea>
        <a class="bx-btn bx-btn--sm" @click="uploadBase64">Base64转图片URL</a>
      </div>
      <div class="bx-preview">
        <img v-if="imageBase64" :src="imageBase64"/>
      </div>
    </div>
    <div class="demo-title"></div>
  </div>
</template>
<script>
  import Uploader from '@packages/components/uploader/uploader';
  import Loading from '@packages/components/loading/loading';
  import Api from '@/utils/api.js'
  var FILEDIR = 'tinsurance_refund';
  export default {
    data () {
      return {
        imageOSS: null,
        imageServer: null,
        base64: null,
        imageBase64: null
      }
    },
    methods: {
      getSuffix: function (filename) {
        var pos = filename.lastIndexOf('.')
        var suffix = '';
        if (pos !== -1) {
          suffix = filename.substring(pos)
        }
        return suffix;
      },
      uploadBase64: function () {
        var self = this;
        if (!self.base64) {
          console.log('请输入base64内容');
          return false;
        }
        // eslint-disable-next-line
        var uploader = new Uploader(null, {
          url: window.location.origin + '/oss/upload',
          data: {
            success_action_status: 200
          },
          autoUpload: false,
          base64: self.base64,
          onBefore: function (file) {
            Api.getAuthInfo(FILEDIR).then(function (response) {
              var data = response.data.data;
              // 正式情况使用
              // uploader.options.url = data.host;
              uploader.options.data.signature = data.signature;
              uploader.options.data.policy = data.policy;
              uploader.options.data.OSSAccessKeyId = data.accessid;
              uploader.options.data.key = data.dir + data.fileName + '.png';
              uploader.upload();
            });
          },
          onSuccess: function () {
            self.imageBase64 = 'http://media.winbaoxian.com/' + this.options.data.key;
          },
          onError: function (xhr, status, message) {
            console.log(xhr, status, message);
          }
        });
      }
    },
    mounted: function () {
      var self = this;
      self.$nextTick(function () {
        // eslint-disable-next-line
        var uploaderOSS = new Uploader('.bx-uploader-oss', {
          url: window.location.origin + '/oss/upload',
          autoUpload: false,
          data: {
            success_action_status: 200
          },
          compress: {
            type: 'image/jpeg',
            width: 1000,
            height: 1000
          },
          onBefore: function (file) {
            Loading.show();
            Api.getAuthInfo(FILEDIR).then(function (response) {
              var data = response.data.data;
              // 正式情况使用
              // uploaderOSS.options.url = data.host;
              uploaderOSS.options.data.signature = data.signature;
              uploaderOSS.options.data.policy = data.policy;
              uploaderOSS.options.data.OSSAccessKeyId = data.accessid;
              uploaderOSS.options.data.key = data.dir + data.fileName + self.getSuffix(file.name);
              uploaderOSS.upload();
            });
          },
          onSuccess: function () {
            self.imageOSS = 'http://media.winbaoxian.com/' + this.options.data.key;
          },
          onError: function (xhr, status, message) {
            console.log(xhr, status, message);
          },
          onComplete: function () {
            Loading.hide();
            console.log('complete');
          },
          onProgress: function (percent) {
            console.log(percent);
          }
        });
        // eslint-disable-next-line
        var uploaderServer = new Uploader('.bx-uploader-server', {
          url: window.location.origin + '/management/learningContent/uploadImage',
          compress: {
            type: 'image/jpeg',
            width: 1000,
            height: 1000
          },
          xhrFields: {
            'withCredentials': true
          },
          onBefore: function () {
            Loading.show();
          },
          onSuccess: function (response) {
            if (response.success) {
              self.imageServer = response.data.url;
            }
          },
          onError: function (xhr, status, message) {
            console.log(xhr, status, message);
          },
          onComplete: function () {
            Loading.hide();
            console.log('complete');
          }
        });
      });
    }
  }
</script>
<style scoped>
  .bx-uploader {
    position: relative;
    margin: 0 15px;
  }

  .bx-uploader img {
    display: block;
  }

  .bx-input-file {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    border: 0;
    outline: 0;
    opacity: 0;
    filter: alpha(opacity=0);
  }

  .bx-preview img {
    width: 100%;
  }

  .upload-background {
    width: 100%;
  }

  .upload-btn {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 50px;
    transform: translate(-50%, -50%);
  }

  .bx-uploader-textarea {
    width: 100%;
    border: 1px solid #CCC;
  }
</style>



// WEBPACK FOOTER //
// src/views/Uploader.vue